import { Loader2, RefreshCw } from "lucide-react";
import { DropdownMenuItem } from "@/core/components/ui/dropdown-menu";
import { Stack } from "@/core/components/ui/stack";
import { Typography } from "@/core/components/ui/typography";
import type { PayBreakdownPeriod, PayBreakdownRerunAction } from "./types";

export interface PayBreakdownRerunMenuAction {
  period: PayBreakdownPeriod | undefined;
  action: PayBreakdownRerunAction;
}

export const isPayBreakdownRerunMenuActionVisible = (
  rerun: PayBreakdownRerunMenuAction | undefined,
) => !!rerun?.period && rerun.action.isVisible;

interface PayBreakdownRerunMenuItemProps {
  rerun: PayBreakdownRerunMenuAction;
}

export const PayBreakdownRerunMenuItem = ({
  rerun,
}: PayBreakdownRerunMenuItemProps) => {
  if (!isPayBreakdownRerunMenuActionVisible(rerun)) return null;

  const { action } = rerun;

  const isDisabled = !action.canRunPeriod || action.isRunning;
  const disabledReason = isDisabled ? action.disabledReason : undefined;

  return (
    <DropdownMenuItem
      disabled={isDisabled}
      aria-busy={action.isRunning}
      onSelect={action.onRun}
    >
      {action.isRunning ? (
        <Loader2 className="h-4 w-4 animate-spin" />
      ) : (
        <RefreshCw className="h-4 w-4" />
      )}
      <Stack gap="none">
        Rerun payroll
        {disabledReason && (
          <Typography variant="bodyW3">{disabledReason}</Typography>
        )}
      </Stack>
    </DropdownMenuItem>
  );
};
